<template>
    <div v-show="shown" @click="clicked"
         class="absolute h-10 w-10 bg-pink-600 text-white flex flex-row justify-center items-center rounded-full cursor-pointer left-19/20 top-9/10 transform hover:scale-200"
         style="z-index: 500; transition: all .5s ease-in-out"
         id="toggle-onboarding">
        <icon
                name="question-circle"
        />
    </div>
</template>

<script>
import Icon from "../Icon.vue";

export default {
  components: {Icon},
  props: {
    shown: {
      type: Boolean,
      required: true
    }
  },

  name: "HelpBubble",

  methods: {
    clicked() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>

</style>
